<template>
  <section class="section">
    <h1
      class="
        has-text-centered has-text-weight-bold
        subtitle
        is-size-4-mobile is-size-3-desktop
        pdx-small-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Which Reality Shows are the Most Stressful to Watch?
    </h1>
    <h2
      class="
        has-text-centered
        subtitle
        is-size-6-mobile is-size-4-desktop
        pdx-medium-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Among some of Britain's most popular reality shows, tensions run highest
      for those who watch Love Island.<br /><br />
      More than <strong>155,412 stressed tweets</strong> were posted during the
      2021 season – the highest amount of all shows in the study. So if you
      fancy a relaxing night in, make sure you DON’T watch
      <strong>Love Island</strong> and try
      <strong>Made in Chelsea</strong> instead!
    </h2>

    <chart-tab showType="Reality TV"></chart-tab>
  </section>
</template>

<script>
  import ChartTab from "@/components/ChartTab";
  export default {
    components: { ChartTab },
  };
</script>

<style lang="scss" scoped>
  .section {
    background: linear-gradient(#d9edf6, #ffffff);
  }
</style>
